<template>
  <div v-if="isLoading" class="global-loader">
    <v-progress-circular
      indeterminate
      size="64"
      width="6"
      color="primary"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['isLoading'])
  }
}
</script>

<style scoped>
.global-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  color: #1F4529;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
